'use strict';

var Webapi__Dom__Node = require("./Webapi__Dom__Node.bs.js");

var Webapi__Dom__Types = require("./Webapi__Dom__Types.bs.js");

var Webapi__Dom__Element = require("./Webapi__Dom__Element.bs.js");

var Webapi__Dom__EventTarget = require("./Webapi__Dom__EventTarget.bs.js");

var Webapi__Dom__GlobalEventHandlers = require("./Webapi__Dom__GlobalEventHandlers.bs.js");

function Impl(T) {
  var contentEditable = function (self) {
    return Webapi__Dom__Types.decodeContentEditable(self.contentEditable);
  };

  var setContentEditable = function (self, value) {
    self.contentEditable = Webapi__Dom__Types.encodeContentEditable(value);
  };

  var dir = function (self) {
    return Webapi__Dom__Types.decodeDir(self.dir);
  };

  var setDir = function (self, value) {
    self.dir = Webapi__Dom__Types.encodeDir(value);
  };

  return {
    ofElement: Webapi__Dom__Element.asHtmlElement,
    contentEditable: contentEditable,
    setContentEditable: setContentEditable,
    dir: dir,
    setDir: setDir
  };
}

var include = Webapi__Dom__Node.Impl({});
Webapi__Dom__EventTarget.Impl({});
Webapi__Dom__GlobalEventHandlers.Impl({});
var include$1 = Webapi__Dom__Element.Impl({});

function contentEditable(self) {
  return Webapi__Dom__Types.decodeContentEditable(self.contentEditable);
}

function setContentEditable(self, value) {
  self.contentEditable = Webapi__Dom__Types.encodeContentEditable(value);
}

function dir(self) {
  return Webapi__Dom__Types.decodeDir(self.dir);
}

function setDir(self, value) {
  self.dir = Webapi__Dom__Types.encodeDir(value);
}

var nodeType = include.nodeType;
var asHtmlElement = include$1.asHtmlElement;
var ofNode = include$1.ofNode;
var insertAdjacentElement = include$1.insertAdjacentElement;
var insertAdjacentHTML = include$1.insertAdjacentHTML;
var insertAdjacentText = include$1.insertAdjacentText;
var ofElement = Webapi__Dom__Element.asHtmlElement;
exports.Impl = Impl;
exports.nodeType = nodeType;
exports.asHtmlElement = asHtmlElement;
exports.ofNode = ofNode;
exports.insertAdjacentElement = insertAdjacentElement;
exports.insertAdjacentHTML = insertAdjacentHTML;
exports.insertAdjacentText = insertAdjacentText;
exports.ofElement = ofElement;
exports.contentEditable = contentEditable;
exports.setContentEditable = setContentEditable;
exports.dir = dir;
exports.setDir = setDir;
/* include Not a pure module */